import { mybSupplyManagement } from '@/api/index'

// export function getInterval (data, params) {
//   const extendUrl = params.urlParam ? '?' + params.urlParam : ''
//   return publicData.request({
//     method: 'post',
//     url: '/Getinterval' + extendUrl
//   })
// }

export function getDynamicType (data) {
  return mybSupplyManagement.request({
    method: 'post',
    url: '/getDynamicType',
    data
  })
}
export function getDynamicButton (data) {
  return mybSupplyManagement.request({
    method: 'post',
    url: '/getDynamicButton',
    data
  })
}
export function GetSupplyRecords (data) {
  return mybSupplyManagement.request({
    method: 'post',
    url: '/GetSupplyRecords',
    data
  })
}
